<template>
  <div class="signup-flow" v-if="currentFlowStep === signupFlowSteps.enterDetails">
    <introduction-with-promo v-if="promotion && isPromotionEligible" :next="() => setCurrentFlowStep(signupFlowSteps.enterCode)"/>
    <introduction v-else :next="() => setCurrentFlowStep(signupFlowSteps.enterCode)"/>
  </div>
  <signup-enter-code v-else-if="currentFlowStep === signupFlowSteps.enterCode"
                     :next="onEnterCode"/>
</template>

<script>

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntroductionWithPromo from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/IntroductionWithPromo';
import SubscriptionStateApi from '@/api/SubscriptionStateApi';
import Segment from '@/Segment';
import Introduction from './steps/Introduction.vue';
import SignupEnterCode from './steps/SignupEnterCode.vue';
import router from '../../../../../router';

export default {
  name: 'SignupFlow',
  components: {
    Introduction,
    SignupEnterCode,
    IntroductionWithPromo,
  },
  async created() {
    if (this.promoCode) {
      await this.fetchPromotion(this.promoCode);
    }
    if (this.promotion && this.isPromotionExpired) {
      Segment.trackUserGot('ExpiredPromotionUsed', { promotion: this.promotion, promoCode: this.promoCode });
    }
    this.setCurrentFlowStep(this.signupFlowSteps.enterDetails);
  },
  props: {
    promoCode: {
      type: String,
    },
  },
  computed: {
    ...mapState('signup', ['currentFlowStep']),
    ...mapState('promotions', ['promotion']),
    ...mapGetters('signup', ['signupFlowSteps']),
    ...mapGetters('promotions', ['isPromotionEligible']),
    isPromotionExpired() {
      return this.promotion && !this.isPromotionEligible;
    },
  },
  methods: {
    ...mapMutations('signup', ['setCurrentFlowStep']),
    ...mapActions('promotions', ['fetchPromotion']),
    async onEnterCode() {
      if (this.promotion) {
        await SubscriptionStateApi.createBenefitByPromoCode(this.promoCode);
      }
      router.push({ path: '/ob' });
    },
  },
};
</script>

<style lang="scss" scoped>
.signup-flow {
  height: 100%;
}
</style>
